import { browserName, deviceType, osName } from 'react-device-detect';

import { OnboardingContextState } from '@/contexts/onboardingContext';
import isRunningInReactNativeWebView from '@/utils/isRunningInReactNativeWebView';

export const getInitialPayload = (data: OnboardingContextState, queryParams: URLSearchParams) => {
  return {
    version: data.version,
    step: data.step,
    sessionId: data.sessionId,
    expiresAt: data.expiresAt,
    expiredAt: data.expiredAt,
    recaptchaSiteKey: data.recaptchaSiteKey,
    initializedData: {
      urlParams: Object.fromEntries(queryParams.entries()),
      httpReferrerUrl: document.referrer,
      currentUrl: window.location.href,
      locale: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isWebView: isRunningInReactNativeWebView(),
      osName: osName,
      browserName: browserName,
      deviceType: deviceType
    }
  };
};
